import { connect } from 'react-redux';

import { submitAccountNote } from 'mastodon/actions/account_notes';

import AccountNote from '../components/account_note';

const mapStateToProps = (state, { account }) => {
  const accountId = account.get('id');
  return {
    value: state.relationships.getIn([accountId, 'note']) || '',
  };
};

const mapDispatchToProps = (dispatch, { account }) => ({

  onSave (value) {
    dispatch(submitAccountNote({ accountId: account.get('id'), note: value }));
  },

});

export default connect(mapStateToProps, mapDispatchToProps)(AccountNote);
